import * as React from 'react';
import { deleteCheck } from './firebase';
import { auth } from './firebase';

export function ChecksTable(props) {
  const [checks, setChecks] = React.useState(props.checks);
  const setStateFunctions = props.setStateFunctions;

  React.useEffect(() => {
    setChecks(props.checks);
  }, [props.checks]);

  function handleRowClick(check) {
    setStateFunctions.amount(check.amount)
    setStateFunctions.payee(check.payee)
    setStateFunctions.memo(check.memo)
    setStateFunctions.notes(check.notes)
    if (setStateFunctions.checkNumber) {
      setStateFunctions.checkNumber(check.checkNumber || '')
    }
  }

  function handleDelete(e, check) {
    e.stopPropagation();
    const userId = auth.currentUser ? auth.currentUser.uid : null;
    if (!userId) return;
    deleteCheck(check.id, userId).then(() => {
      setChecks(checks.filter(c => c.id !== check.id));
    });
  }

  if (!checks || checks.length === 0) {
    return <p style={{ color: '#999', textAlign: 'center' }}>No checks yet.</p>
  }

  return (
    <table className="checks-table">
      <thead>
        <tr>
          <th>Check #</th>
          <th>Date</th>
          <th>Pay To</th>
          <th>Amount</th>
          <th>Memo</th>
          <th style={{ width: 50, textAlign: 'center' }}></th>
        </tr>
      </thead>
      <tbody>
        {checks.map((check) => (
          <tr key={check.id} onClick={() => handleRowClick(check)} style={{ cursor: 'pointer' }}>
            <td>{check.checkNumber || '-'}</td>
            <td>{check.date}</td>
            <td>{check.payee}</td>
            <td>${check.amount}</td>
            <td>{check.memo}</td>
            <td style={{ textAlign: 'center' }}>
              <button
                className="btn-delete"
                onClick={(e) => handleDelete(e, check)}
                title="Delete check"
              >
                🗑
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
